//
// Main Nav functions
//
export default class MainNav {
  constructor() {

    // Mobile nav dropdown elements
    this.mobileNav = document.getElementById('site-header__mobile-nav');
    this.mobileNavTrigger = document.getElementById('js-site-header__mobile-nav-trigger');
    // Nested items
    this.mobileNavDropdownTriggers = document.querySelectorAll('.js-site-header__mobile-nav-inner-ctrl');

    if (!this.mobileNav) return;

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
   togglemobileNav(event) {
    event.preventDefault();
    if (this.mobileNav.classList.contains('site-header__mobile-nav--open')) {
      this.mobileNavTrigger.classList.remove('site-header__mobile-nav-trigger--open');
      this.mobileNav.classList.remove('site-header__mobile-nav--open');
    } else {
      this.mobileNavTrigger.classList.add('site-header__mobile-nav-trigger--open');
      this.mobileNav.classList.add('site-header__mobile-nav--open');
    }
  }

  toggleMobileNavDropdown(event) {
    event.preventDefault();

    // Get closest dropdown
    let currentDropdownTrigger = event.currentTarget;
    let currentDropdown = currentDropdownTrigger.nextElementSibling;

    if (currentDropdown.classList.contains('site-header__mobile-nav-list--children-open')) {
      currentDropdownTrigger.innerHTML = "&plus;";
      currentDropdown.classList.remove('site-header__mobile-nav-list--children-open');
    } else {
      currentDropdownTrigger.innerHTML = "&minus;";
      currentDropdown.classList.add('site-header__mobile-nav-list--children-open');
    }
  }

  addEventHandling() {
    this.mobileNavTrigger.addEventListener('click', this.togglemobileNav.bind(this));

    this.mobileNavDropdownTriggers.forEach(dropdownTrigger => {
      dropdownTrigger.addEventListener('click', this.toggleMobileNavDropdown.bind(this));
    });

  }
}